export const MEMO_DRAG_DATA_FORMAT = 'application/x-clustar-memo';
